var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'cursor-pointer': _vm.canReact,
    flex: true,
    'flex-row': true,
    'items-center': _vm.isUsedInPostExpandedView,
    'items-end': !_vm.isUsedInPostExpandedView,
    'text-dark-text-200': !_vm.isPadletColorSchemeDark,
    'text-light-text-200': _vm.isPadletColorSchemeDark,
    'hover-hover:hover:text-dark-text-100': !_vm.isPadletColorSchemeDark,
    'hover-hover:hover:text-light-text-100': _vm.isPadletColorSchemeDark,
    'hover-hover:focus:text-grape-500': !_vm.isPadletColorSchemeDark,
    'hover-hover:focus:text-canary-500': _vm.isPadletColorSchemeDark,
    'hover-hover:active:text-grape-500': !_vm.isPadletColorSchemeDark,
    'hover-hover:active:text-canary-500': _vm.isPadletColorSchemeDark,
  },attrs:{"title":_vm.title},on:{"click":_vm.startReacting}},[(!_vm.myReactionId)?_c('OzIcon',{key:"grade_icon_not_reacted",attrs:{"size":_vm.isUsedInPostExpandedView && _vm.isSmallerThanTabletPortrait ? 24 : 20,"name":"checkbox_person_outline"}}):_c('OzIcon',{key:"grade_icon_reacted",class:_vm.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500',attrs:{"name":"checkbox_filled_check","size":_vm.isUsedInPostExpandedView && _vm.isSmallerThanTabletPortrait ? 24 : 20}}),_vm._v(" "),(_vm.reactionCount > 0)?_c('span',{key:"average",class:['ltr:ml-1 rtl:mr-1', 'font-sans', _vm.fontSizeClass]},[_vm._v("\n    "+_vm._s(_vm.avgRating + '/' + _vm.maxGrade)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.reactionCount > 0)?_c('span',{key:"count",class:['ltr:ml-1 rtl:mr-1', 'font-sans', _vm.fontSizeClass]},[_vm._v("("+_vm._s(_vm.reactionCount)+")")]):_vm._e(),_vm._v(" "),(_vm.canReact && !_vm.currentUserReacted)?_c('span',{key:"gradeButton",class:[
      _vm.currentUserReacted ? 'ltr:ml-1 rtl:mr-1' : 'ltr:ml-2 rtl:mr-2',
      'font-sans',
      _vm.isUsedInPostExpandedView
        ? _vm.isSmallerThanTabletPortrait
          ? 'text-body-small'
          : 'text-body-extra-small'
        : 'text-12-18',
      'font-semibold',
    ],attrs:{"role":"button"}},[_vm._v("\n    "+_vm._s(_vm.__('Grade'))+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }